// Phase 6 — operator-readable rendering of canonical config keys.
//
// The backend ships canonical lowercase keys (``gps``,
// ``beidou,galileo,glonass,gps``); the UI prefers compact labels
// (``GPS``, ``все 4``). Single helper used by every analytics
// component so all four surfaces (cards, heatmap, scatter,
// filters) speak the same language.

const SINGLE_SYSTEM_LABELS: Record<string, string> = {
  gps: 'GPS',
  glonass: 'GLONASS',
  galileo: 'Galileo',
  beidou: 'BeiDou',
};

const ALL_FOUR_KEY = 'beidou,galileo,glonass,gps';

export function formatConfig(config: string): string {
  if (config === ALL_FOUR_KEY) return 'все 4';
  if (SINGLE_SYSTEM_LABELS[config]) return SINGLE_SYSTEM_LABELS[config];
  // Custom combo (e.g. "galileo,gps") — render the lowercase parts
  // capitalised so "galileo,gps" → "Galileo + GPS".
  return config
    .split(',')
    .map((p) => SINGLE_SYSTEM_LABELS[p] ?? p)
    .join(' + ');
}

export const ALL_FOUR_CONFIG_KEY = ALL_FOUR_KEY;
